import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { containerQueryProps } from '@resy/ui-kitchen';

import BlogPost from '../BlogPost/BlogPost';

import './BlogPostGrid.scss';

const BlogPostGrid = (props) => {
  const {
    internalPosts,
    onTagClick,
    containerQuery,
    containerQuery: { md, lg },
  } = props;

  if (!internalPosts.length) return null;

  return (
    <section className="BlogPostGrid">
      <div className={cx('BlogPostGrid--divider', {
        'BlogPostGrid--divider--md': md,
      })}
      />

      <div className={cx('BlogPostGrid__Wrapper', {
        'BlogPostGrid__Wrapper--md': md,
      })}
      >
        <div className={cx('BlogPostGrid__Grid', {
          'BlogPostGrid__Grid--md': md,
          'BlogPostGrid__Grid--lg': lg,
        })}
        >
          {internalPosts.map((post, index) => {
            const {
              url,
              title,
              image,
              tag: { name, url: tagUrl },
              id,
              isContentTile = false,
            } = post;

            /* eslint-disable react/no-array-index-key */
            return (
              <BlogPost
                key={`post_${index}`}
                url={url}
                tagUrl={tagUrl}
                title={title}
                image={image}
                name={name}
                onTagClick={onTagClick}
                containerQuery={containerQuery}
                id={id}
                isContentTile={isContentTile}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};

BlogPostGrid.propTypes = {
  internalPosts: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string,
    image: PropTypes.string,
    tag: PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
    }),
  })),
  containerQuery: containerQueryProps,
  onTagClick: PropTypes.func.isRequired,
};

BlogPostGrid.defaultProps = {
  internalPosts: [],
  containerQuery: {},
};

BlogPostGrid.displayName = 'BlogPostGrid';
export default BlogPostGrid;
